/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataRequestModel } from '../../models/data-request-model';
import { IntegrationDataResponse } from '../../models/integration-data-response';

export interface IntegrationRetrieveDataPersonIdPost$Params {

/**
 * Person identifier.
 */
  personId: string;
  
    /**
     * Data request model specifying date range and data types.
     */
    body?: DataRequestModel
}

export function integrationRetrieveDataPersonIdPost(http: HttpClient, rootUrl: string, params: IntegrationRetrieveDataPersonIdPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<IntegrationDataResponse>> {
  const rb = new RequestBuilder(rootUrl, integrationRetrieveDataPersonIdPost.PATH, 'post');
  if (params) {
    rb.path('personId', params.personId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<IntegrationDataResponse>;
    })
  );
}

integrationRetrieveDataPersonIdPost.PATH = '/Integration/RetrieveData/{personId}';
